import { http } from './http';
import type { NotificationDto, PageResponse } from './types';

export const notificationsApi = {
  list(page = 0, size = 30): Promise<PageResponse<NotificationDto>> {
    return http
      .get<PageResponse<NotificationDto>>('/notifications', { params: { page, size } })
      .then((r) => r.data);
  },

  unreadCount(): Promise<number> {
    return http
      .get<{ unread: number }>('/notifications/unread-count')
      .then((r) => r.data.unread);
  },

  markRead(id: string): Promise<void> {
    return http.patch(`/notifications/${id}/read`).then(() => undefined);
  },

  markAllRead(): Promise<void> {
    return http.patch('/notifications/read-all').then(() => undefined);
  },
};
